const FETCH_SUPPLIERS= "FETCH_SUPPLIERS";
const FETCH_SUPPLIERS_SUCCESS = "FETCH_SUPPLIERS_SUCCESS";
const FETCH_SUPPLIERS_ERROR = "FETCH_SUPPLIERS_ERROR";
const UPDATE_SUPPLIERS = "UPDATE_SUPPLIERS";
const UPDATE_SUPPLIERS_SUCCESS = "UPDATE_SUPPLIERS_SUCCESS";
const UPDATE_SUPPLIERS_ERROR = "UPDATE_SUPPLIERS_ERROR";
const DELETE_SUPPLIERS = "DELETE_SUPPLIERS";
const DELETE_SUPPLIERS_SUCCESS = "DELETE_SUPPLIERS_SUCCESS";
const DELETE_SUPPLIERS_ERROR = "DELETE_SUPPLIERS_ERROR";
const CREATE_SUPPLIERS = "CREATE_SUPPLIERS";
const CREATE_SUPPLIERS_SUCCESS = "CREATE_SUPPLIERS_SUCCESS";
const CREATE_SUPPLIERS_ERROR = "CREATE_SUPPLIERS_ERROR";
const IS_ADDING_UPDATE = "IS_ADDING_UPDATE";

export {
  FETCH_SUPPLIERS,
  FETCH_SUPPLIERS_SUCCESS,
  FETCH_SUPPLIERS_ERROR,
  UPDATE_SUPPLIERS,
  UPDATE_SUPPLIERS_SUCCESS,
  UPDATE_SUPPLIERS_ERROR,
  DELETE_SUPPLIERS,
  DELETE_SUPPLIERS_SUCCESS,
  DELETE_SUPPLIERS_ERROR,
  CREATE_SUPPLIERS,
  CREATE_SUPPLIERS_SUCCESS,
  CREATE_SUPPLIERS_ERROR,
  IS_ADDING_UPDATE,
};
